import React from 'react';
import styled from 'styled-components';
import { Colors } from './Colors';

const Pre = styled.pre`
    padding: .5rem;
    border: solid 1px ${Colors.border};
    white-space: pre-wrap;
    word-break: break-word;
    background: ${Colors.l1};
    color: ${Colors.text};
    border-radius: .5rem;
    font-family: Fira Code, monospace;
`;

export const DebugInspect = React.memo<{ value: any }>(({ value }) => {
    return <Pre>{JSON.stringify(value, null, 2)}</Pre>;
});
